import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/react';

export const ScrollButton = ({
  direction,
  visible,
  onClick,
}: {
  direction: 'left' | 'right';
  visible: boolean;
  onClick: () => void;
}) => {
  const width = 20;

  return (
    <Box
      position="absolute"
      top={0}
      bottom={0}
      width={`${width}px`}
      display="flex"
      alignItems="center"
      justifyContent={direction === 'left' ? 'flex-start' : 'flex-end'}
      left={direction === 'left' ? 0 : undefined}
      right={direction === 'right' ? 0 : undefined}
      cursor="pointer"
      onClick={onClick}
      opacity={visible ? 1 : 0}
      pointerEvents={visible ? 'auto' : 'none'}
      transition="opacity 0.2s"
      backgroundColor="background.primary"
      zIndex={1}
    >
      {direction === 'left' ? (
        <ChevronLeftIcon
          w={4}
          h={4}
          color="var(--ui-text-muted)"
          _hover={{ color: 'var(--ui-text-normal)' }}
        />
      ) : (
        <ChevronRightIcon
          w={4}
          h={4}
          color="var(--ui-text-muted)"
          _hover={{ color: 'var(--ui-text-normal)' }}
        />
      )}
    </Box>
  );
};
